var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { DropdownDivider, DropdownHeader, Grid, Icon, Input, Select } from "semantic-ui-react";
import { getWithAuthn } from "../../RequestHelpers";
import { isPredictedTarget, targetHasMIValidatedEntry } from "../KitToFormStateUtilityFunctions";
import { abbreviateRnaWithModal } from "../rna-fish/KitDisplay";
import { uniqueBy } from "../rna-fish/ProbeSetForm";
import { cleanUpIshRnaSeq, debounce } from "./EditKitForm";
import { miValidatedIcon, RnaCishEditableOrganism, RnaCishEditableTarget } from "./ProbeSetForm";
var ProKitProbeForm = /** @class */ (function (_super) {
    __extends(ProKitProbeForm, _super);
    function ProKitProbeForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debounceSearchQueryChange = debounce(function (event, data) {
            _this.onSearchQueryChange(event, data);
        }, 500);
        _this.noSequenceMessage = function () {
            return React.createElement("div", { style: { paddingTop: '0.5rem' } }, "\uD83E\uDDEC Don\u2019t have the sequence handy? You can place your order and submit the target sequence later.");
        };
        _this.onRnaChange = function (_, data) {
            _this.props.onProProbeStateChange(function () {
                var _a;
                return {
                    target: (_a = _this.props.proKitProbeState.target) === null || _a === void 0 ? void 0 : _a.withRna(cleanUpIshRnaSeq(data.value))
                };
            }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.predictedOrVerifiedLabel = function (target) {
            if (target.predictedTarget) {
                return React.createElement("div", { style: { paddingTop: '0.5rem' } },
                    React.createElement(Icon, { name: 'circle', color: 'yellow' }),
                    React.createElement("a", { target: "_blank", href: "https://www.ncbi.nlm.nih.gov/books/NBK50679/#RefSeqFAQ.what_is_the_difference_between" }, "Predicted Sequence from NCBI"));
            }
            else {
                return React.createElement("div", { style: { paddingTop: '0.5rem' } },
                    React.createElement(Icon, { name: 'circle', color: 'green' }),
                    React.createElement("a", { target: "_blank", href: "https://www.ncbi.nlm.nih.gov/books/NBK50679/#RefSeqFAQ.what_is_the_difference_between" }, "Verified Sequence from NCBI"));
            }
        };
        _this.effectiveOrganisms = function () {
            var organisms = _this.props.catalog.probeSet.catalog.organisms.map(function (o) {
                return {
                    text: o.name + " " + (o.scientificName.length > 0 && o.scientificName !== o.name ? '(' + o.scientificName + ')' : ''),
                    content: o.name + " " + (o.scientificName.length > 0 && o.scientificName !== o.name ? '(' + o.scientificName + ')' : ''),
                    value: o.id
                };
            });
            if (_this.props.proKitProbeState.organism.id === -1 && _this.props.proKitProbeState.organism.name.trim() !== "") {
                organisms = organisms.concat([
                    {
                        text: _this.props.proKitProbeState.organism.name,
                        content: _this.props.proKitProbeState.organism.name,
                        value: _this.props.proKitProbeState.organism.id
                    }
                ]);
            }
            return uniqueBy(organisms, function (o) { return o.value; });
        };
        _this.onOrganismChange = function (_, data) {
            var organism = data.value;
            var selectedOrganism = _this.props.catalog.probeSet.catalog.organisms.find(function (o) { return o.id === organism; });
            _this.props.onProProbeStateChange(function () {
                return {
                    organism: selectedOrganism ? RnaCishEditableOrganism.fromLibOrg(selectedOrganism) : RnaCishEditableOrganism.default(),
                    target: RnaCishEditableTarget.default(-1),
                    targets: [],
                    searchQuery: ""
                };
            }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.onAddCustomOrganism = function (_, data) {
            var ct = data.value;
            _this.props.onProProbeStateChange(function () { return ({
                organism: new RnaCishEditableOrganism(ct, "", -1)
            }); }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.onAddCustomTarget = function (_, data) {
            var ct = data.value;
            _this.props.onProProbeStateChange(function () { return ({
                probeSetFamily: undefined,
                target: new RnaCishEditableTarget(ct, "", "", "", 20, -1, false, false, undefined)
            }); }, _this.props.channel, _this.props.onUserSelection);
        };
        _this.noOrganismSelected = function () {
            var organism = _this.props.proKitProbeState.organism;
            return organism.id === -1 && organism.name.trim() === "";
        };
        _this.noTargetSelected = function () {
            var target = _this.props.proKitProbeState.target;
            return target.id === -1 && target.name.trim() === "";
        };
        _this.onSearchChange = function (event, data) {
            if (_this.props.proKitProbeState.organism.id !== -1 && data.searchQuery.length !== 0) {
                // Set the form state immediately
                _this.props.onProProbeStateChange(function () { return ({ enableCustomTarget: false }); }, _this.props.channel);
                // Call the debounced function
                _this.debounceSearchQueryChange(event, data);
            }
        };
        _this.onSearch = function (options, value) {
            if (value.trim().length === 0) {
                return [];
            }
            else {
                return uniqueBy(options, function (o) { return o.value; });
            }
        };
        _this.onTargetChange = function (_, data) {
            if (typeof data.value === "number") {
                _this.props.onProProbeStateChange(function () { return ({
                    searchLoading: true
                }); }, _this.props.channel, function () {
                    getWithAuthn("/rna/search/probeSetFamilyId/" + encodeURIComponent(data.value))
                        .then(function (resp) {
                        if (resp.status === 200) {
                            return resp.json();
                        }
                        else {
                            return undefined;
                        }
                    })
                        .then(function (jsonFamily) {
                        if (jsonFamily !== undefined && jsonFamily.psf != null) {
                            _this.props.onProProbeStateChange(function () {
                                var _a;
                                var target = jsonFamily.psf;
                                var accession = (_a = target.defaultVariant.accession) === null || _a === void 0 ? void 0 : _a.transcriptAccession;
                                var variantId = jsonFamily.variantId;
                                return {
                                    searchLoading: false,
                                    target: new RnaCishEditableTarget(target.geneSymbol, target.description, accession ? accession : "", target.defaultVariant.targetMrnaSeq, target.defaultVariant.probeSetSize, target.id, targetHasMIValidatedEntry(target), isPredictedTarget(target), variantId)
                                };
                            }, _this.props.channel, _this.props.onUserSelection);
                        }
                        else {
                            _this.props.onProProbeStateChange(function () {
                                return {
                                    searchLoading: false,
                                    target: RnaCishEditableTarget.default(-1),
                                    probeSetFamilies: [],
                                    searchQuery: ""
                                };
                            }, _this.props.channel, _this.props.onUserSelection);
                        }
                    });
                });
            }
            else {
                _this.props.onProProbeStateChange(function () {
                    return {
                        searchLoading: false,
                        probeSetFamily: undefined,
                        target: undefined,
                        searchQuery: "",
                        probeSetFamilies: [],
                    };
                }, _this.props.channel, _this.props.onUserSelection);
            }
        };
        _this.onSearchQueryChange = function (_, data) {
            var path = "";
            if (_this.props.proKitProbeState.organism.id === -1 || data.searchQuery.length === 0) {
                _this.props.onProProbeStateChange(function () { return ({
                    probeSetFamilies: [],
                    probeSetFamily: undefined,
                    searchQuery: "",
                    target: data.searchQuery.length === 0 ? undefined : _this.props.proKitProbeState.target
                }); }, _this.props.channel);
                return;
            }
            path = "/rna/search/id/" +
                (encodeURIComponent(_this.props.proKitProbeState.organism.id) + "/targetGene/") +
                ("" + encodeURIComponent(data.searchQuery));
            _this.props.onProProbeStateChange(function () { return ({
                searchLoading: true
            }); }, _this.props.channel, function () {
                getWithAuthn(path)
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    _this.props.onProProbeStateChange(function () {
                        if (resp !== undefined) {
                            return {
                                searchLoading: false,
                                enableCustomTarget: true,
                                searchQuery: data.searchQuery,
                                probeSetFamilies: resp.probeSetFamilyResults,
                                probeSetFamily: undefined
                            };
                        }
                        else {
                            return {
                                searchLoading: false,
                                enableCustomTarget: true,
                                probeSetFamily: undefined,
                                searchQuery: data.searchQuery
                            };
                        }
                    }, _this.props.channel, _this.props.onUserSelection);
                });
            });
        };
        _this.searchQueryIsSynonymForProbeSetFamily = function (f, searchQuery) {
            return !!f.synonyms.find(function (s) { return s.toLowerCase() === searchQuery.toLowerCase(); });
        };
        _this.searchQueryIsExactMatchToProbeSetFamily = function (f, searchQuery) {
            return f.geneSymbol.toLowerCase() === searchQuery.toLowerCase();
        };
        _this.effectiveTargets = function () {
            var exactMatchFamilies = _this.props.proKitProbeState.probeSetFamilies.filter(function (psf) {
                return _this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.props.proKitProbeState.searchQuery);
            });
            var synonymFamilies = _this.props.proKitProbeState.probeSetFamilies.filter(function (psf) {
                return _this.searchQueryIsSynonymForProbeSetFamily(psf, _this.props.proKitProbeState.searchQuery);
            });
            var otherProbeSetFamilies = _this.props.proKitProbeState.probeSetFamilies.filter(function (psf) {
                return !_this.searchQueryIsSynonymForProbeSetFamily(psf, _this.props.proKitProbeState.searchQuery) &&
                    !_this.searchQueryIsExactMatchToProbeSetFamily(psf, _this.props.proKitProbeState.searchQuery);
            });
            var options = [];
            options = options.concat((exactMatchFamilies.length > 0 || synonymFamilies.length > 0) ? [
                React.createElement(DropdownHeader, { key: 'recommended-header', content: 'Recommended' }),
                React.createElement(DropdownDivider, { key: 'recommended-divider' })
            ] : []).concat(exactMatchFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat(synonymFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat((otherProbeSetFamilies.length !== 0 && _this.props.proKitProbeState.searchQuery !== '') ? [
                React.createElement(DropdownHeader, { key: 'other-header', content: "Other Results for " + _this.props.proKitProbeState.searchQuery }),
                React.createElement(DropdownDivider, { key: 'other-divider' })
            ]
                : []).concat(otherProbeSetFamilies.map(function (f) {
                var symAndDes = React.createElement(React.Fragment, null,
                    f.geneSymbol,
                    " ",
                    React.createElement("em", null, f.description.length > 0 ? '(' + f.description + ')' : ''));
                var text = _this.probeSetFamilyHasMIValidatedEntry(f) ?
                    React.createElement(React.Fragment, null,
                        React.createElement(Icon, { name: miValidatedIcon }),
                        symAndDes)
                    : symAndDes;
                return {
                    content: symAndDes,
                    className: f.geneSymbol,
                    text: text,
                    value: f.id
                };
            })).concat(!_this.noTargetSelected() ? [
                {
                    text: _this.props.proKitProbeState.target.name,
                    value: -1
                }
            ] : []);
            return options;
        };
        _this.probeSetFamilyHasMIValidatedEntry = function (f) {
            if (_this.props.proKitProbeState.target.id === f.id) {
                return _this.props.proKitProbeState.target.miValidated;
            }
            else {
                return false;
            }
        };
        return _this;
    }
    ProKitProbeForm.prototype.render = function () {
        var organism = this.props.proKitProbeState.organism;
        var target = this.props.proKitProbeState.target;
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { className: this.props.disabled ? "disabled" : "", columns: 2, verticalAlign: "middle" },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Organism")),
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement(Select, { className: organism.name.trim() !== "" ?
                                'selection-box selected-ish' : "selection-box", placeholder: 'Type-in or select a organism.', options: this.effectiveOrganisms(), onChange: this.onOrganismChange, search: true, allowAdditions: true, additionLabel: 'Custom Organism: ', additionPosition: "bottom", icon: false, onAddItem: this.onAddCustomOrganism, clearable: true, selectOnBlur: false, selectOnNavigation: false, value: this.noOrganismSelected() ? "" : organism.id }))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Target")),
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement(Select, { additionLabel: "Custom Target: ", additionPosition: "bottom", allowAdditions: this.props.proKitProbeState.enableCustomTarget, className: !this.noTargetSelected() ? 'selection-box selected-ish' : "selection-box", clearable: true, disabled: this.noOrganismSelected(), loading: this.props.proKitProbeState.searchLoading, onAddItem: this.onAddCustomTarget, onChange: this.onTargetChange, onSearchChange: this.onSearchChange, selectOnBlur: false, selectOnNavigation: false, options: this.noOrganismSelected() ? [] : this.effectiveTargets(), placeholder: 'Type to search for a target.', search: this.onSearch, spellCheck: false, value: this.noTargetSelected() ? "" : target.id }))),
                this.props.proKitProbeState.target.id !== -1 &&
                    React.createElement(Grid.Row, { className: "sequence-info" },
                        React.createElement(Grid.Column, { width: 3 }),
                        React.createElement(Grid.Column, { width: 12 }, this.predictedOrVerifiedLabel(this.props.proKitProbeState.target))),
                target && React.createElement(React.Fragment, null,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                            React.createElement("p", { className: 'ish-subheader-tag' }, "Sequence")),
                        React.createElement(Grid.Column, { width: 12 },
                            React.createElement(Input, { className: target.targetMrnaSeq.length > 0 ? 'selection-box selected-ish' : "selection-box", placeholder: 'RNA Target Sequence', onChange: this.onRnaChange, value: target ? target.targetMrnaSeq : "" }))),
                    React.createElement(Grid.Row, { className: 'sequence-info' },
                        React.createElement(Grid.Column, { width: 3 }),
                        React.createElement(Grid.Column, { width: 12 },
                            React.createElement("label", { htmlFor: "rna-target-seq" },
                                "RNA Target Sequence ", "(" + target.targetMrnaSeq.length + " nt)",
                                ": ",
                                target.targetMrnaSeq.length > 0 && abbreviateRnaWithModal(target.targetMrnaSeq, true)),
                            (target.targetMrnaSeq.length === 0) && this.noSequenceMessage())))));
    };
    return ProKitProbeForm;
}(React.PureComponent));
export default ProKitProbeForm;
//# sourceMappingURL=ProKitProbeForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/ProKitProbeForm.js
// module id = 1152
// module chunks = 0